import request from '@/utils/request'

// 发布信息模块所有接口
// 每个接口中的：takePeeridAndSessionid代表需要把peerid和sessionid都加进参数里，在request.js里统一处理，不再每个接口里都加这2个字段
export default {
  // 发布信息-并购买方/投资方需求-保存
  createMergerProject: (data) => {
    return request({
      data,
      url: `/merger/project/create_merger_project`,
      method: 'POST',
      takePeeridAndSessionid: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  // 管理项目/信息里的子菜单的列表接口，共用一个，通过service_type入参
  userProjectList: (data) => {
    return request({
      data,
      url: `/merger/manage/get_user_project_list`,
      method: 'GET',
      takePeeridAndSessionid: true
    })
  },
  // 管理项目/信息里的子菜单的详情接口
  projectDetail: (data) => {
    return request({
      data,
      url: `/merger/project/get_merge_info`,
      method: 'GET',
      takePeeridAndSessionid: true
    })
  },
  // 管理项目/信息里的子菜单的修改接口
  projectUpdate: (data) => {
    return request({
      data,
      url: `/merger/project/update_merger_project`,
      method: 'GET',
      takePeeridAndSessionid: true
    })
  },
  // 获取当前用户总项目数量
  projectNum: () => {
    return request({
      data: {},
      url: `/project/manage/get_user_total_project_count`,
      method: 'GET',
      takePeeridAndSessionid: true
    })
  },
  // 管理项目-获取上传${会议 / 行业}文件列表
  projectSourceList: (data) => {
    return request({
      data,
      url: `/merger/resource/get_project_resource_list`,
      method: 'GET',
      takePeeridAndSessionid: true
    })
  },
  // 管理项目-上传${会议 / 行业}资料
  projectSourceSave: (data) => {
    return request({
      data,
      url: `/merger/resource/save_project_resources`,
      method: 'POST',
      takePeeridAndSessionid: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  // 发布信息-人才猎头信息-保存
  createRecruit: (data) => {
    return request({
      data,
      url: `/recruit/project/create_recruit_project`,
      method: 'POST',
      takePeeridAndSessionid: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  // 发布信息-人才猎头信息-列表
  recruitList: (data) => {
    return request({
      data,
      url: `/recruit/manage/get_user_recruit_list`,
      method: 'GET',
      takePeeridAndSessionid: true
    })
  },
  // 发布信息-人才猎头信息-修改
  recruitUpdate: (data) => {
    return request({
      data,
      url: `/recruit/project/update_recruit_project`,
      method: 'POST',
      takePeeridAndSessionid: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  // 发布信息-人才猎头信息-详情
  recruitDetail: (data) => {
    return request({
      data,
      url: `/recruit/project/get_recruit_info`,
      method: 'GET',
      takePeeridAndSessionid: true
    })
  },
  // 发布信息-厂房/写字楼/园区-出售/招租信息-保存
  // 发布信息-厂房/写字楼/园区-购买/租赁信息-保存
  // 发布信息-寻找客户/供应商信息-保存
  // 发布信息-雇用专业中介机构信息-保存
  // 发布信息-寻找智库专家信息-保存
  // 发布信息-寻找资方-保存
  createFinance: (data) => {
    return request({
      data,
      url: `/finance/project/create_finance_project`,
      method: 'POST',
      takePeeridAndSessionid: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  // 管理项目-厂房/写字楼/园区-出售/招租-项目列表
  // 管理项目-厂房/写字楼/园区-购买/租赁-项目列表
  // 管理项目--寻找客户/供应商-项目列表
  // 管理项目--雇用专业中介机构-项目列表
  // 管理项目--寻找智库专家-项目列表
  // 管理项目--寻找资方-项目列表
  userFinanceList: (data) => {
    return request({
      data,
      url: `/finance/manage/get_user_finance_list`,
      method: 'GET',
      takePeeridAndSessionid: true
    })
  },
  // 管理项目-厂房/写字楼/园区-出售/招租-项目修改
  financeUpdate: (data) => {
    return request({
      data,
      url: `/finance/project/update_finance_project`,
      method: 'POST',
      takePeeridAndSessionid: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  // 管理项目-厂房/写字楼/园区-出售/招租-项目详情
  financeDetail: (data) => {
    return request({
      data,
      url: `/finance/project/get_finance_info`,
      method: 'GET',
      takePeeridAndSessionid: true
    })
  }
}
